import React, { useEffect } from 'react';
import NavBar from './NavBar';
import './Projects.css';

function Projects() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="projects-page">
      <NavBar />

      <section className="projects-hero">
        <div className="projects-hero-content">
          <h1>Projects</h1>
          <p className="projects-subtitle">Innovative applications built with Orchestral AI</p>
        </div>
      </section>

      <div className="projects-content">
        {/* ASTER */}
        <section className="project-section">
          <div className="project-container">
            <h2>ASTER: Agentic Science Toolkit for Exoplanet Research</h2>
            <p>
              A specialized toolkit designed to accelerate exoplanet research through intelligent agent orchestration.
              ASTER provides tools for data analysis, visualization, and automated hypothesis generation in the field
              of exoplanet discovery and characterization.
            </p>
          </div>
        </section>

        {/* HEPTAPOD */}
        <section className="project-section">
          <div className="project-container">
            <h2>HEPTAPOD: HEP Toolkit for Agentic Planning Orchestration and Deployment</h2>
            <p>
              An advanced toolkit for High Energy Physics research that enables automated event generation and analysis.
              HEPTAPOD empowers researchers to explore complex particle physics phenomena through sophisticated
              multi-agent workflows.
            </p>
          </div>
        </section>

        {/* VQC Research */}
        <section className="project-section">
          <div className="project-container">
            <h2>Agent Assisted Research for Variational Quantum Circuit Design</h2>
            <p>
              Leveraging AI agents to explore and optimize designs for Variational Quantum Circuits (VQCs).
              This project demonstrates how agent-based approaches can accelerate quantum computing research
              and circuit optimization.
            </p>
          </div>
        </section>

        {/* Bayesian Belief Agents */}
        <section className="project-section">
          <div className="project-container">
            <h2>Bayesian Belief Agents</h2>
            <p>
              Exploring the intersection of Bayesian reasoning and agent-based systems to create more
              robust and interpretable AI decision-making frameworks.
            </p>
          </div>
        </section>

        {/* Fermilab Collaboration */}
        <section className="project-section highlight">
          <div className="project-container">
            <h2>Fermilab Collaboration</h2>
            <p>
              We are working with Fermilab to develop a more powerful suite of agentic tools for High Energy
              Physics Research. This collaboration aims to push the boundaries of what's possible in particle
              physics through advanced AI agent orchestration.
            </p>
          </div>
        </section>

        {/* Philosophy Debate */}
        <section className="project-section">
          <div className="project-container">
            <h2>Philosophical Debate Agents</h2>
            <p>
              Philosophy professors requested a system where two agents could debate while playing the roles
              of different philosophers. Using Orchestral AI, this complex multi-agent interaction was built
              in just five minutes, demonstrating the power and flexibility of the framework.
            </p>
            <p className="project-note">More details coming soon...</p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Projects;
